module.exports = __webpack_public_path__ + "media/src/pages/Onboarding/images/success-3-722a48d9b4ae27c7727539380672feac.png";